import {toast} from 'react-toastify'
import {Message} from '../../../_metronic/helpers'

import {addAsset, addAssetWithUser, getAssets, getAssetsById} from '../../../api/AssetsAPI'
import {getUserAsset} from './AssignAssetsFunction'

const getTodayDateString = () => {
  const today = new Date()
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
    today.getDate()
  ).padStart(2, '0')}`
}

export function safeISODate(value: any): string | null {
  if (!value) return null

  // YYYY-MM-DD (input[type=date])
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return `${value}T00:00:00.000Z`
  }

  // DD-MM-YYYY (manual / display)
  if (typeof value === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [dd, mm, yyyy] = value.split('-')
    return `${yyyy}-${mm}-${dd}T00:00:00.000Z`
  }

  return null
}



export const getAsset = (
  setAsset: Function,
  setAPIStatus: Function,
  query: Record<string, string | number | undefined> = {},
  setPagination: Function = () => {}
) => {
  setAPIStatus((prev: any) => ({ ...prev, loading: true }))
  getAssets(query).then((res: any) => {
    if (res.statusCode === 200) {
      const assetsWithIndex = (res.data || []).map((assets: any, index: number) => ({
        ...assets,
        index: ((res.meta?.page || 1) - 1) * (res.meta?.pageSize || 0) + index + 1,
      }))

      setAsset(assetsWithIndex)
      if (res.meta) {
        const lastPage = Math.max(1, res.meta.totalPages || 1)
        setPagination({
          ...res.meta,
          page: Math.min(Math.max(1, res.meta.page || 1), lastPage),
        })
      }

      setAPIStatus((prev: any) => ({ ...prev, loading: false }))
    } else {
      setAPIStatus((prev: any) => ({
        ...prev,
        loading: false,
        error: res.message,
      }))
    }
  }).catch((error: any) => {
    setAPIStatus((prev: any) => ({ ...prev, loading: false, error: error?.message || 'Failed to load assets' }))
  })
}


// form save function

export const handleSubmit = (
  InputField: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string

    status: string
    assignee: string
  },
  // getAsset: Function,
  setAsset: Function,
  setEditId: Function,
  initialState: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string

    status: string
    assignee: string
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function,
  fetchAssets: Function,
  setIsCommentPopupOpen: Function
) => { 
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      addAsset(InputField).then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message)
          fetchAssets()
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      setIsCommentPopupOpen(true)
      setIsAddUserModalOpen(false)
      // Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
      //   if (result.isConfirmed) {
      //     // setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))

      //   }
      // })
    }
  } else {
  }
}
//Hide to that code 
// export const handleFormFieldSubmit = (
//   formField: {
//     id:string
//     user: string
//     issueDate: string
//     location: string
//     locationType: string
//     returnDate:string
//   },
//   setAsset: Function,
//   setEditId: Function,
//   initialState: {
//     user: string
//     issueDate: string
//     location: string
//     locationType: string
//   },
//   setFormField: Function,
//   editId: string | null,
//   cancelSubmit: Function,
//   setAPIStatus: Function,
//   setInputError: Function,
//   validateFormField: Function,
//   setSubmitAPIStatus: Function,
//   setModalOpen: Function,
//   fetchAssets: Function,
//   setUserAseet: Function
// ) => {
//   let {cnt, error} = validateFormField(formField)
//   setInputError(error)

//   console.log('ASSET ID (editId):', editId)
//   console.log('USER ID:', formField.user)


//   if (cnt === 0) {

//   addAssetWithUser(formField, editId).then((res: any) => {
//     if (res.statusCode === 200 || res.statusCode === 201) {
//       getAsset(setAsset, setAPIStatus);
//       getUserAsset(setUserAseet, setAPIStatus);
//       toast.success(res.message);
//       cancelSubmit(setFormField, initialState, setEditId, setInputError);
//       setEditId(null);
//       setModalOpen(false);
//     } else {
//       Message(res.message, 'error');
//     }
//   });
// }
//  else {
//   }
// }
//Added to that code
export const handleFormFieldSubmit = async (
  formField,
  setAsset,
  setEditId,
  initialState,
  setFormField,
  editId,
  cancelSubmit,
  setAPIStatus,
  setInputError,
  validateFormField,
  setSubmitAPIStatus,
  setModalOpen,
  fetchAssets,
  setUserAseet
) => {
  try {
    // START LOADING HERE
    setSubmitAPIStatus({ loading: true })

    let { cnt, error } = validateFormField(formField)
    setInputError(error)

    if (cnt !== 0) {
      return
    }

    const res = await addAssetWithUser(formField, editId)

    if (res.statusCode === 200 || res.statusCode === 201) {
      await getAsset(setAsset, setAPIStatus)
      await getUserAsset(setUserAseet, setAPIStatus)

      toast.success(res.message)

      cancelSubmit(setFormField, initialState, setEditId, setInputError)
      setEditId(null)
      setModalOpen(false)
    } else {
      Message(res.message, 'error')
    }

  } catch (error) {
    console.error(error)
    toast.error('Something went wrong')
  } finally {
    // ALWAYS RESET LOADING
    setSubmitAPIStatus({ loading: false })
  }
}

export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string
    returnDate: string
    status: string
    assignee: string
  }
) => {
  let target = event.target as HTMLInputElement
  if (target.name === 'locationType') {
    const defaultLocation = target.value === 'onsite' ? 'Pune' : ''
    setInputField({
      ...InputField,
      [target.name]: target.value,
      location: defaultLocation,
    })
  } else if (target.name.startsWith('userAssets.')) {
    const userAssetsField = target.name.split('userAssets.')[1]

    setInputField((prevInputField) => ({
      ...prevInputField,
      userAssets: {
        ...prevInputField.userAssets,
        [userAssetsField]: target.value,
      },
    }))
  } else {
    setInputField({
      ...InputField,
      [target.name]: target.type === 'checkbox' ? target.checked : target.value,
    })
  }
}

export const handleFormFieldChange = (
  event: React.SyntheticEvent,
  setFormField: Function,
  FormField: {
    user: string
    issueDate: string
    locationType: string
    location: string
  }
) => {
  let target = event.target as HTMLInputElement
  if (target.name === 'locationType') {
    const defaultLocation = target.value === 'onsite' ? 'Pune' : ''
    setFormField({
      ...FormField,
      [target.name]: target.value,
      location: defaultLocation,
    })
  } else if (target.name.startsWith('userAssets.')) {
    const userAssetsField = target.name.split('userAssets.')[1]

    setFormField((prevInputField) => ({
      ...prevInputField,
      userAssets: {
        ...prevInputField.userAssets,
        [userAssetsField]: target.value,
      },
    }))
  } else {
    setFormField({
      ...FormField,
      [target.name]: target.type === 'checkbox' ? target.checked : target.value,
    })
  }
}

export const getAssetById = (
  id: string,
  InputField: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string

    status: string
    assignee: string
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getAssetsById(id).then((res: any) => {
    if (res) {
      setInputField({
        ...InputField,
        category: res.data.category,
        subCategory: res.data.subCategory,
        brand: res.data.brand,
        serialNo: res.data.serialNo,
        description: res.data.description,
        purchaseDate: res.data.purchaseDate,
        issueDate: res.data.userAssets?.[0]?.issueDate || '',
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error')
    }
  })
}

export const validateForm = (InputField: {
  category: string
  subCategory: string
  brand: string
  serialNo: string
  description: string
  purchaseDate: string
  returnDate: string
  status: string
  assignee: string
}) => {
  let cnt = 0
  const error: any = {}
  if (!InputField.category || !InputField.category.trim()) {
    cnt = cnt + 1
    error.category = 'Please select a Category.'
  }
  if (!InputField.subCategory || !InputField.subCategory.trim()) {
    cnt = cnt + 1
    error.subCategory = 'Please select a Sub Category.'
  }

  if (!InputField.brand || !InputField.brand.trim()) {
    cnt = cnt + 1
    error.brand = 'Please enter a Asset Brand.'
  } else if (InputField.brand.length > 35) {
    cnt = cnt + 1
    error.brand = 'Asset Brand  must not exceed 35 characters.'
  }

  if (!InputField.serialNo || !InputField.serialNo.trim()) {
    cnt = cnt + 1
    error.serialNo = 'Please enter a Serial No.'
  } else if (!/^[a-zA-Z0-9@._-]+$/.test(InputField.serialNo)) {
    cnt = cnt + 1
    error.serialNo =
      'Please enter a valid Serial No. using only alphanumeric characters with this special symbol [@,.,_,-].'
  } else if (InputField.serialNo.length > 50) {
    cnt = cnt + 1
    error.serialNo = 'Serial No. must not exceed 50 characters.'
  } else if (InputField.serialNo.length < 5) {
    cnt = cnt + 1
    error.serialNo = 'Serial No. must be at least 5 characters.'
  }
  if (!InputField.purchaseDate || !InputField.purchaseDate.trim()) {
    cnt = cnt + 1
    error.purchaseDate = 'Please select/enter a valid Purchase Date.'
  } else {
    if (InputField.purchaseDate.slice(0, 10) > getTodayDateString()) {
      cnt = cnt + 1
      error.purchaseDate = 'Purchase Date must not be greater than the current date.'
    }
    
  }
  

  if (!InputField.description || !InputField.description.trim()) {
    cnt = cnt + 1
    error.description = 'Please enter a Description.'
  } else if (InputField.description.length > 500) {
    cnt = cnt + 1
    error.description = 'Description must not exceed 500 characters.'
  }
  return {error, cnt}
}
export const validateFormField = (formField: {
  user: string
  issueDate: string
  returnDate?: string
  locationType: string
  location: string
  purchaseDate?: string
}) => {
  let cnt = 0
  const error: any = {}

  if (!formField?.user) {
    cnt = cnt + 1
    error.user = 'Please select a User Name.'
  }
  if (!formField?.issueDate || !formField?.issueDate.trim()) {
    cnt = cnt + 1
    error.issueDate = 'Please select/enter a valid Issue Date.'
  } else {
    // const selectedDate = new Date(formField.issueDate)
    // const purchase = new Date(formField.purchaseDate)
    // const currentDate = new Date()

    // if ((selectedDate > currentDate)&&(selectedDate < purchase)) {
    //   cnt = cnt + 1
    //   error.issueDate = 'Issue Date must not be greater and less than the current date.'
    // }

    const issueDate = formField.issueDate.slice(0, 10)

    if (issueDate > getTodayDateString()) {
      cnt++
      error.issueDate = 'Issue Date must not be greater than the current date.'
    } else if (formField.purchaseDate) {
      const purchaseDate = formField.purchaseDate.slice(0, 10)
      if (issueDate < purchaseDate) {
        cnt++
        error.issueDate = 'Issue Date must not be earlier than Purchase Date.'
      }
    }

  }
 
    
  
   // ✅ Add Return Date validation here
  if (formField.returnDate) {
  const returnDate = formField.returnDate.slice(0, 10)
  const issueDate = formField.issueDate.slice(0, 10)

  if (returnDate > getTodayDateString()) {
    cnt++
    error.returnDate = 'Return Date must not be later than the current date.'
  } else if (issueDate && returnDate < issueDate) {
      cnt++
      error.returnDate = 'Return Date cannot be before Issue Date.'
  }
}

  if (!formField.locationType || !formField.locationType.trim()) {
    cnt = cnt + 1
    error.locationType = 'Please select a Onsite/Remote.'
  }
  if (!formField.location || !formField.location.trim()) {
    cnt = cnt + 1
    error.location = 'Please enter a Location.'
  }
  return {error, cnt}
}

export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string

    status: string
    assignee: string
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}

export const cancelFormSubmit = (
  setFormField: Function,
  formField: {
    user: string
    issueDate: string
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setFormField(formField)
  setInputError({})
}
